import { SignupButton } from '@src/components/signup-button/SignupButton.component'
import { themeToUiKitButton } from '@src/helpers/uikit'
import { Breakpoints } from '@src/hooks/useBreakpoint'
import { useWindowDimensions } from '@src/hooks/useWindowDimensions'
import { mixpanelService } from '@src/srv/mixpanel.service'
import { DatoCmsFileField } from '@src/typings/dato-cms-assets'
import { ReactNode } from 'react'
import { NcImage } from '../nc-image/NcImage.component'
import styles from './EffectivenessSectionBlocks.module.scss'

export interface EffectivenessSectionBlocksProps {
  effectivenessComparison: {
    headline: string
    signupButtonText?: string
    labelHormonal: string
    labelNonHormonal: string
    effectivenessTable: {
      icon: {
        alt: string
        url: string
      }
      id: string
      effectiveness: string
      hasHormones: boolean
      method: string
    }[]
    footnote: string
  }
  mobileEffectivenessBackground: {
    media: DatoCmsFileField
  }
  desktopEffectivenessBackground: {
    media: DatoCmsFileField
  }
}

export function EffectivenessSectionBlocks({
  effectivenessComparison,
  mobileEffectivenessBackground,
  desktopEffectivenessBackground,
}: EffectivenessSectionBlocksProps): ReactNode {
  const { width } = useWindowDimensions()
  const isMobile = width && width < Breakpoints.bpMedium

  function trackClick(): void {
    mixpanelService.trackClick('effectiveness-signup-button-click')
  }

  return (
    <section className={styles.EffectivenessSectionBlocks} uid="effectiveness-table">
      <div className={styles.EffectivenessSectionBlocks__overlay} />
      <div className={styles.EffectivenessSectionBlocks__container}>
        <NcImage
          className={styles.EffectivenessSectionBlocks__background}
          {...(isMobile
            ? mobileEffectivenessBackground.media
            : desktopEffectivenessBackground.media)}
        />
        <h3 className={styles.EffectivenessSectionBlocks__headline}>
          {effectivenessComparison.headline}
        </h3>

        <div className={styles.EffectivenessTable}>
          <p className={styles.EffectivenessTable__heading}>
            {effectivenessComparison.labelNonHormonal}
          </p>
          <hr />
          {effectivenessComparison.effectivenessTable.map(item => {
            if (!item.hasHormones) {
              return (
                <div className={styles.EffectivenessTable__item} key={item.id}>
                  <p className={styles.EffectivenessTable__label}>{item.method}</p>
                  <img
                    className={styles.EffectivenessTable__image}
                    alt={item.icon.alt}
                    src={item.icon.url}
                  />
                  <p className={styles.EffectivenessTable__percentage}>{item.effectiveness}</p>
                </div>
              )
            }
          })}
        </div>

        <div className={styles.EffectivenessTable}>
          <p className={styles.EffectivenessTable__heading}>
            {effectivenessComparison.labelHormonal}
          </p>
          <hr />
          {effectivenessComparison.effectivenessTable.map(item => {
            if (item.hasHormones) {
              return (
                <div className={styles.EffectivenessTable__item} key={item.id}>
                  <p className={styles.EffectivenessTable__label}>{item.method}</p>
                  <img
                    className={styles.EffectivenessTable__image}
                    alt={item.icon.alt}
                    src={item.icon.url}
                  />
                  <p className={styles.EffectivenessTable__percentage}>{item.effectiveness}</p>
                </div>
              )
            }
          })}
        </div>

        <div
          className={styles.EffectivenessSectionBlocks__footnote}
          dangerouslySetInnerHTML={{ __html: effectivenessComparison.footnote }}
        />

        <div className={styles.EffectivenessSectionBlocks__button} onClick={trackClick}>
          <SignupButton
            uid="effectiveness-signup-button"
            theme="whiteBrandPurple"
            refactory={{
              ...themeToUiKitButton('whiteBrandPurple'),
              uid: 'effectiveness-signup-button',
              href: '',
            }}
          >
            {effectivenessComparison.signupButtonText}
          </SignupButton>
        </div>
      </div>
    </section>
  )
}
